export default (options) => {
  return {
    applyHtmlTags: ['pre'].map(tag => tag.toLowerCase())
  }
}
